import { useContext } from "react";
import { ProcessContext } from "../../../../../../contexts/ProcessContext";

export const usePricings = () => {
  const {
    state: { loan, pricingByLoanId },
    dispatch,
  } = useContext(ProcessContext);

  const requestGetPricingByLoanId = () => {
    if (loan.id) {
      dispatch({
        type: "REQUEST_GET_PRICING_BY_LOAN_ID",
        payload: loan.id,
      });
    }
  };

  return { requestGetPricingByLoanId, pricingByLoanId };
};
